import Vue from 'vue'
import Vuex from 'vuex'
import Stores from 'store2'
import Cookies from 'js-cookie'
import { SET_TOKEN, SET_LAYOUT } from './mutations'
import { postLogin, postLogout } from '@/api/common'

Vue.use(Vuex)

let token

;(function initToken() {
  const _token = Stores.get('token') || Cookies.get('token')

  token = _token || null
}())

export default new Vuex.Store({
  state: {
    token,
    layout: 'div',
    // medium / small / mini
    formSize: 'small',
    buttonSize: 'small'
  },
  getters: {
    isLogin: (state) => !!state.token,
    layout: (state) => state.layout
  },
  mutations: {
    [SET_TOKEN](state, token) {
      state.token = token
    },
    [SET_LAYOUT](state, layout = 'div') {
      state.layout = layout
    }
  },
  actions: {
    async login({ commit }, form = {}) {
      return new Promise((resolve, reject) => {
        postLogin(form).then((token) => {
          Stores.set('token', token)
          Cookies.set('token', token, { path: '' })
          commit(SET_TOKEN, token)
          resolve(token)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    async logout({ commit }) {
      return new Promise((resolve, reject) => {
        postLogout().then(() => {
          Stores.remove('token')
          Cookies.remove('token', { path: '' })
          commit(SET_TOKEN, null)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  modules: {
  }
})
